import { CreateInvoiceDefaults } from "models/propTypes/invoicePropTypes";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { AppState } from "store";
import { UrlHelper } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import useActivateInvoiceCreationDialog from "./useActivateInvoiceCreationDialog";
import { displayDialog } from "store/actions/utilActions";

function useCreateInvoice(defaults?: CreateInvoiceDefaults) {
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const activationStatus = useSelector((store: AppState) => store.auth.selectedCompany.invoiceActivationState);

  const { getActivateInvoiceCreationDialog, getWaitingForActivationDialog } = useActivateInvoiceCreationDialog();

  return async function onCreateInvoice() {
    switch (activationStatus) {
      case WintSuperkollAPIModel.InvoiceActivationState.Activated:
        navigate(UrlHelper.formatPath(`/Invoice/Create`), {
          state: {
            background: location,
            customerId: defaults?.customer?.id,
            customerName: defaults?.customer?.name,
            productId: defaults?.productId, 
            preserveSearch: true
          },
        });
        return;
      case WintSuperkollAPIModel.InvoiceActivationState.NotActivated:
        dispatch(displayDialog(getActivateInvoiceCreationDialog()));
        return;
      case WintSuperkollAPIModel.InvoiceActivationState.WaitingForActivation:
        dispatch(displayDialog(getWaitingForActivationDialog()));
        return;
    }
  };
}

export default useCreateInvoice;
